import { saveAs } from "file-saver";

const download = (url, name) => saveAs(url, name);

export default download;
